import { render, staticRenderFns } from "./ManageAccountMenu.vue?vue&type=template&id=295a6278&"
import script from "./ManageAccountMenu.vue?vue&type=script&lang=js&"
export * from "./ManageAccountMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports